import { createStyles, makeStyles } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import React from 'react';
import { FlutterFeatures } from './flutter-features';
import { FlutterHero } from './flutter-hero';
import { FlutterMessaging } from './flutter-messaging';
import { FlutterWaitlist } from './flutter-waitlist';
import { FlutterWhat } from './flutter-what';
import { Profiles } from './profiles';
import { Schools } from './schools';

const useStyles = makeStyles((theme) => createStyles({
    wrapper: {
        overflowX: 'hidden',
        width: '100%',
    },
}))


export const HomePage = ({
    location,
}: RouteComponentProps) => {
    const classes = useStyles({});
    return (
        <div className={classes.wrapper}>
            <FlutterHero />
            <FlutterWhat />
            <Profiles />
            <FlutterMessaging />
            <Schools />
            <FlutterFeatures />
            <FlutterWaitlist />
        </div>
    );
}

